module.exports = __webpack_public_path__ + "img/gallery-5.4b0bba25.webp";